import { getAuthHeaders } from '@/utils/authManager';
import { publicApiCall, getGateWayUrl, httpCall } from '../common/util';
import HeaderActionApiMapping from '../containers/CreationForms/DiaryCreation/actionURLMapping'
// let oapi = getGateWayUrl();
// let org_id  = $('#_co').val();
// let orgHeader = `org${process.env.header_seperator}id`;
let baseURL = "https://gateway.ccdev.cloud/1.0";

// todo : cremove if it is not in use
export const actionsTodo = async (payload) => {
    var options = {
        method: 'PUT',
        url: (payload.isComplete == 'true' || payload.isComplete == true) ?
        `${baseURL}todo/complete/${payload.id}` : `${baseURL}todo/reopen/${payload.id}`,
        headers: getAuthHeaders(),
    };
    return httpCall(options);
}
